import React from 'react';

interface AvionLogoProps {
  /** Width in pixels. Height scales proportionally (original: 1120×459). Default 140. */
  width?: number;
  /**
   * 'light' — for light/white backgrounds (SVG with black tagline text, default).
   * 'dark'  — for dark/navy backgrounds (SVG with white tagline text).
   */
  variant?: 'light' | 'dark';
}

/**
 * Avion brand logo — uses the official SVG asset from /public.
 * Use variant="dark" when placing on a dark/navy background so the
 * "Your Trusted Technology Partner" tagline renders in white.
 */
export default function AvionLogo({ width = 140, variant = 'light' }: AvionLogoProps) {
  // Original SVG viewBox: 1120 × 459
  const height = Math.round((width / 1120) * 459);
  const src = variant === 'dark' ? '/avion-logo-dark.svg' : '/avion-logo.svg';

  return (
    <img
      src={src}
      alt="Avion — Your Trusted Technology Partner"
      width={width}
      height={height}
      style={{ display: 'block', objectFit: 'contain' }}
      draggable={false}
    />
  );
}
